module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, _vm._l((_vm.updateList), function(item, i) {
    return _c('radio-item', _vm._b({
      key: i,
      attrs: {
        "hasSubBottomBorder": i < _vm.updateList.length - 1,
        "isFullBorder": _vm.isFullBorder,
        "isShowBorder": _vm._isColmo ? true : _vm.isShowBorder,
        "isLast": i === _vm.updateList.length - 1,
        "data-evt-dofRadioItemChecked": ""
      },
      on: {
        "dofRadioItemChecked": function($event) {
          return _vm.dofRadioItemChecked(i, $event)
        }
      }
    }, 'radio-item', item, false))
  }), 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-75905dab", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75905dab","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-radio-list/index.vue
// module id = 629
// module chunks = 0 1